import { render, staticRenderFns } from "./tagCell.vue?vue&type=template&id=5e64460e&scoped=true"
import script from "./tagCell.vue?vue&type=script&lang=js"
export * from "./tagCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e64460e",
  null
  
)

export default component.exports